// Mock data for Tabaccheria N.16

export const heroData = {
  title: "Tabaccheria N.16",
  subtitle: "Punto Servizi & Rivenditore Svapo",
  location: "Reggio nell'Emilia",
  description: "Il tuo punto di riferimento per tabacchi, svapo, servizi al cittadino e molto altro",
  cta: "Vieni a trovarci",
  ctaSecondary: "Prenota Prodotto SVAPO"
};

export const svapoProducts = [
  {
    id: 1,
    brand: "KIWI",
    category: "Pods & Resistenze",
    products: ["KIWI GO+", "KIWI AIR", "KIWI 0% NICOTINA", "KIWI IWIK", "KIWI LIQUID", "KIWI SPARK", "KIWI 2"],
    image: "https://images.unsplash.com/photo-1585123334904-845d60e97a29?w=500&q=80",
    featured: true
  },
  {
    id: 2,
    brand: "ELFBAR",
    category: "Pods & Resistenze",
    products: ["ELFBAR ELFA", "LOST MARY TOCA", "ELFBAR MASTER", "ELFLIQ Liquid"],
    image: "https://images.unsplash.com/photo-1593640407042-61cb2c89e44d?w=500&q=80",
    featured: true
  },
  {
    id: 3,
    brand: "RELX",
    category: "Kit & Pods",
    products: ["ESSENTIAL KIT", "INFINITY 2 PLUS KIT", "PRO PODS", "2 in 1"],
    image: "https://images.unsplash.com/photo-1606657041112-be379dd15e0b?w=500&q=80",
    featured: true
  },
  {
    id: 4,
    brand: "WAKA",
    category: "Kit & Pods",
    products: ["SOMUCH KIT", "SOMUCH PODS"],
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=500&q=80",
    featured: false
  },
  {
    id: 5,
    brand: "DINNER LADY",
    category: "Kit & Pods",
    products: ["10000 KIT & PODS"],
    image: "https://images.unsplash.com/photo-1566140967404-b8b3932483f5?w=500&q=80",
    featured: false
  },
  {
    id: 6,
    brand: "FUYL",
    category: "Kit & Pods",
    products: ["8000 KIT & PODS"],
    image: "https://images.unsplash.com/photo-1579380909071-c9d419b2e71e?w=500&q=80",
    featured: false
  },
  {
    id: 7,
    brand: "VEEV",
    category: "Starter Kit & Pods",
    products: ["ONE STARTER KIT", "PODS"],
    image: "https://images.unsplash.com/photo-1601024445121-e5b82f020549?w=500&q=80",
    featured: false
  },
  {
    id: 8,
    brand: "VUSE",
    category: "Pods",
    products: ["PODS"],
    image: "https://images.unsplash.com/photo-1580870069867-74c829b8ce1e?w=500&q=80",
    featured: false
  }
];

export const services = [
  {
    id: 1,
    category: "Valori Bollati",
    icon: "FileText",
    items: [
      "Marche da Bollo",
      "Francobolli e Valori Postali"
    ],
    color: "cyan"
  },
  {
    id: 2,
    category: "Trasporti",
    icon: "Bus",
    items: [
      "Biglietti Autobus Urbani",
      "Biglietti Autobus Extraurbani"
    ],
    color: "orange"
  },
  {
    id: 3,
    category: "Servizi al Cittadino",
    icon: "CreditCard",
    items: [
      "Pagamenti Bollettini",
      "PagoPA",
      "Pagamento Multe",
      "Bollo Auto"
    ],
    color: "teal"
  },
  {
    id: 4,
    category: "Servizi Pacchi",
    icon: "Package",
    items: [
      "Punto Poste Ritiri e Spedizioni",
      "Fermapoint BRT Ritiri e Spedizioni"
    ],
    color: "amber"
  }
];

export const contactInfo = {
  name: "Tabaccheria N.16 e Svapo Shop",
  address: "Piazza Gioberti 4/B, angolo Via Emilia Santo Stefano 22/E, Reggio Emilia 42121",
  province: "Provincia di Reggio Emilia",
  whatsapp: "+39 379 271 1214",
  email: "info@tabaccheria16reggio.it",
  city: "Reggio nell'Emilia",
  hours: {
    lunedi: "06:30-13:00, 15:00-19:30",
    martedi: "06:30-13:00, 15:00-19:30",
    mercoledi: "06:30-13:00, 15:00-19:30",
    giovedi: "06:30-13:00, 15:00-19:30",
    venerdi: "06:30-13:00, 15:00-19:30",
    sabato: "06:30-13:00, 15:00-19:30",
    domenica: "Chiuso"
  }
};

export const testimonials = [
  {
    id: 1,
    name: "Marco R.",
    rating: 5,
    text: "Fornitissimi di prodotti svapo! Personale competente e disponibile.",
    date: "2 settimane fa"
  },
  {
    id: 2,
    name: "Giulia M.",
    rating: 5,
    text: "Comodo per tutti i servizi che offre. Non devo più andare in posta!",
    date: "1 mese fa"
  },
  {
    id: 3,
    name: "Alessandro P.",
    rating: 5,
    text: "Migliori prezzi di Reggio Emilia per i prodotti ELFBAR e KIWI.",
    date: "3 settimane fa"
  }
];
